import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { exchangeGoogleSession } from "@/lib/auth";

export const AuthCallback = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { acceptUser, setPrompt } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    exchangeGoogleSession(sessionId || "").then((user) => {
      acceptUser(user);
      navigate("/", { replace: true, state: { scrollTool: true } });
    }).catch((error) => {
      acceptUser(null);
      setPrompt({ kind: "error", message: error.response?.status === 401
        ? "Your sign-in link expired. Please try Google again."
        : "We couldn't complete sign-in. Please try again." });
      navigate("/", { replace: true });
    });
  }, [hash, acceptUser, setPrompt, navigate]);

  return null;
};